import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectCrossratesPlanMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_CROSSRATES_PLAN_MESSAGE);
        this.NonTradableMarkups = [];
        this.MarkupData = [];
        this.Id = 0;
        this.Name = null;
        this.Description = null;
        this.CounterAccountID = 0;
        this.MarkupMeasure = 0;
    }
}
